export const getItem = (key) => {
  const item = sessionStorage.getItem(key);
  if (item === null) return null;
  return JSON.parse(item);
};

export const setItem = (key, value) => {
  return window.sessionStorage.setItem(key, JSON.stringify(value));
};

export const removeItem = (key) => {
  return window.sessionStorage.removeItem(key);
};

const cache = {
  getItem,
  setItem,
  removeItem,
};

export default cache;
